import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import AuthProvider from "./context/AuthContext";
import { ViewportProvider } from "./context/ViewportContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <ViewportProvider>
      <App />
    </ViewportProvider>
  </AuthProvider>
);
